module.exports = "<div class=\"full-screen-disclaimer\"\n     ng-show=\"$ctrl.zoomFactor !== $ctrl.$scope.$openSeadragon.viewportInfo.zoom\">\n  <div class=\"container\">\n    <div class=\"disclaimer row middle-xs\">\n      <h3 class=\"col-xs-12\">\n        <span translate=\"trueview.fullscreen.DISCLAIMER\"></span>\n      </h3>\n    </div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/viewpoints/templates/disclaimer.template.html
// module id = 100
// module chunks = 0